import { Helper } from '../../../../../../classes/helper'
import { cover } from '../../../../../../utility/constant/helper.constant'
import { useMontage } from '../../../../../../context/montage.context'

interface Props {
  isGlass: boolean
}

export const WindowsSideTieBottomBack = ({
  isGlass,
}: Props): JSX.Element | null => {
  const { measure, roof } = useMontage()

  if (!isGlass) return null

  const height =
    11 + Math.tan((measure.userAngle * Math.PI) / 180) * measure.userDepth

  return (
    <mesh
      position={[
        Helper.convertToMeter(measure.userWidth / 2 - cover.bar.height / 2),
        Helper.convertToMeter(measure.userHeight / 2 - height / 2),
        Helper.convertToMeter(1.8),
      ]}
      rotation={[
        Helper.convertAngleToRadiant(0),
        Helper.convertAngleToRadiant(90),
        Helper.convertAngleToRadiant(90),
      ]}
    >
      <boxGeometry
        args={[
          Helper.convertToMeter(measure.userHeight - height / 2),
          Helper.convertToMeter(cover.terraceCover.glassTie),
          Helper.convertToMeter(cover.terraceCover.glassTie),
        ]}
      />
      <meshPhysicalMaterial color={roof.userColor} />
    </mesh>
  )
}
